export const localStoragePrefix = "intraactive.pling.communicator";
export const default001TemplateId = "default-001";
export const darkModeBackgroundColor = "#1f1f1f";
export const darkModeLabelColor: string = "#A8A8A8";
export const darkModeCardBackgroundColor: string = "#323232";
export const darkModeInputFieldBackgroundColor: string = "#414141";
